import { defineRecipe } from "@chakra-ui/react";

export const badgeRecipe = defineRecipe({
  base: {
    borderRadius: "xl",
    textStyle: "xs",
  },

  variants: {
    variant: {
      subtle: {
        bg: "bg.subtle",
        color: "gray.fg",
      },
    },
  },
});
